import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import * as XLSX from "xlsx";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Color } from "../../../GlobalStyles";
import Service from "../../../services/httpService";
import CCService from "../../../services/httpServiceWithoutSuperAdmin";
import SideNavigationBar from "../../reusables/SideNavigationBar/SideNavigationBar";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

const EmployabilityData = () => {
    const navigate = useNavigate();
    const service = new Service();
    const newService = new CCService();
    const [loading, setLoading] = useState(true);
    const [allBatches, setAllBatches] = useState([]);
    const [openMenu, setOpenMenu] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedProcess, setSelectedProcess] = useState(null);
    const [studentList, setStudentList] = useState([]);
    const [loadingStudents, setLoadingStudents] = useState(false);
    // process_id of the card whose CEE report is currently being prepared
    const [downloadingReport, setDownloadingReport] = useState(null);
    const today = new Date();
    const getData = async () => {
        try {
            setLoading(true);
            const res = await service.get(`/getAllCee`);
            const temp_batch = res.data.map((item) => ({
                ...item,
                is_loading: false
            }));
            const sortedBatch = temp_batch.sort((a, b) => {
                const startA = new Date(a.start_date);
                const endA = new Date(a.end_date);
                const startB = new Date(b.start_date);
                const endB = new Date(b.end_date);

                // Determine status
                const isOngoingA = today >= startA && today <= endA;
                const isOngoingB = today >= startB && today <= endB;

                const isUpcomingA = today < startA;
                const isUpcomingB = today < startB;

                const isCompletedA = today > endA;
                const isCompletedB = today > endB;

                // 1. Ongoing first
                if (isOngoingA && !isOngoingB) return -1;
                if (!isOngoingA && isOngoingB) return 1;

                // 2. Upcoming second
                if (isUpcomingA && !isUpcomingB) return -1;
                if (!isUpcomingA && isUpcomingB) return 1;

                // 3. Completed last
                if (isCompletedA && !isCompletedB) return 1;
                if (!isCompletedA && isCompletedB) return -1;

                // Tie-breakers inside each group
                if (isOngoingA && isOngoingB) {
                    // Ongoing → sort by start_date ascending
                    return startA - startB;
                }

                if (isUpcomingA && isUpcomingB) {
                    // Upcoming → sort by start_date ascending
                    return startA - startB;
                }

                if (isCompletedA && isCompletedB) {
                    // Completed → sort by end_date descending (most recently finished first)
                    return endB - endA;
                }

                return 0;
            });
            setAllBatches(sortedBatch);
        } catch (error) {
            console.error("Failed to fetch data:", error);
            // Optionally set an error state here
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const getStatus = (start_date, end_date) => {
        const today = new Date();
        if (today >= new Date(start_date) && today <= new Date(end_date)) {
            return 'Ongoing';
        } else if (today > new Date(end_date)) {
            return 'Completed';
        } else {
            return 'Upcoming';
        }
    }

    const getStyle = (start_date, end_date) => {
        const today = new Date();
        if (today >= new Date(start_date) && today <= new Date(end_date)) {
            return 'green';
        } else if (today > new Date(end_date)) {
            return 'red';
        } else {
            return Color.accent;
        }
    }


    const handleDownload = async (item) => {
        try {
            const url = `/cee/get-candidates?process_id=${item.process_id}`;
            const response = await newService.get(url); // response.data = array of candidates

            console.log("response", response.data);
            const candidates = Array.isArray(response.data)
                ? response.data
                : [response.data];
            console.log("candidates", candidates);

            const rows = candidates.map((row, index) => ({
                "S.No": index + 1,
                "CEE ID": row.ceeId,
                "First Name": row.first_name,
                "Last Name": row.last_name,
                "Email": row.email_id,
                "Phone Number": row.ph_no,
                "Exam Status": row.exam_status,
                "Exam Time": row.exam_time,
                "pernality answers": row.pe,
                "10th": row["10th"],
                "12th": row["12th"],
                "UG": row.UG,
                "PG": row.PG,
                "Diploma": row.Diploma,
                "Internship": row.Internship,
                "Projects": row.Projects,
                "Position of Responsibility": row["Position of Responsibility"],
                "Certificates": row.Certificates,
                "User Profile Details": row["User profile details"],
                "Admit Card Link": row.admit_card,
                "Resume Link": row.resume_link,
                "KYC Photo": row.kyc_pic,
                "ID Proof": row.id_proof,
                "Final exam status": row.final_exam_status,
                "Personality test status": row.is_pe_done,
            }));

            // 🔹 Convert to XLSX
            const worksheet = XLSX.utils.json_to_sheet(rows);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Candidates");

            // 🔹 Generate binary string
            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            // 🔹 Trigger download
            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            const urlBlob = URL.createObjectURL(blob);
            link.href = urlBlob;
            link.download = `candidates_${item.process_id}.xlsx`;
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(urlBlob);
        } catch (error) {
            console.log("error", error);
        }
    };




    // The backend sends the canonical name, fall back to building it ourselves.
    const getFileName = (res, fallback) => {
        const match = res.headers?.["content-disposition"]?.match(/filename="?([^";]+)"?/);
        return match ? match[1] : fallback;
    };

    // With responseType blob an error body is a Blob, not JSON, so it needs unwrapping.
    const getErrorMessage = async (err) => {
        try {
            const text = await err?.response?.data?.text();
            return JSON.parse(text)?.message;
        } catch (e) {
            return null;
        }
    };

    // Full employability report for the process: overall / exam / profile / PE role
    // scores, skills and personality answers. Built server side, we just save it.
    const handleDownloadCeeReport = async (item) => {
        setDownloadingReport(item.process_id);
        try {
            const res = await service.getFile(`/ceeReport`, { process_id: item.process_id });

            if (Number(res.headers?.["x-record-count"]) === 0) {
                toast.info(`No students registered for process ${item.process_id}`);
                setDownloadingReport(null);
                return;
            }

            const url = window.URL.createObjectURL(new Blob([res.data], { type: XLSX_MIME }));
            const link = document.createElement("a");
            link.href = url;
            link.download = getFileName(res, `Final_CEE_Data_${item.process_id}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // Revoking synchronously can cancel the download in some browsers.
            setTimeout(() => window.URL.revokeObjectURL(url), 1000);
        } catch (err) {
            console.log(err);
            const message = await getErrorMessage(err);
            toast.error(message || "Could not download the CEE report");
        }
        setDownloadingReport(null);
    };

    const toggleMenu = (index) => {
        setOpenMenu(openMenu === index ? null : index);
    };

    const fetchStudentsForUpdate = async (item) => {
        try {
            setLoadingStudents(true);
            setSelectedProcess(item);

            const res = await fetch(
                `/api/getStudentsForUpdate/${item.id}` // process_id
            );

            const data = await res.json();
            setStudentList(data.students || []);
            setShowModal(true);
        } catch (err) {
            console.error("Error fetching students:", err);
        } finally {
            setLoadingStudents(false);
        }
    };

    const confirmDeclareStudentReport = async (item) => {
        try {
            const res = await service.put(`/declare-student-report`, {
                process_id: item.process_id,


            })


            if (res.ok) {
                alert("Student report declared successfully");
                setShowModal(false);
            } else {
                alert("Failed declaring report");
            }
        } catch (err) {
            console.error(err);
            alert("Something went wrong!");
        }
    };

    const handeleDeclareCollegeReport = async (item) => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_SCHEDULER_API_URL}/declare-college-report`,
                {
                    process_id: item.process_id,
                    ug_id: item.user_group_id,

                }
            );


        } catch (err) {
            console.error(err);
            alert("Something went wrong!");
        }
    };

    console.log("all batches", allBatches);
    return (
        <div style={styles.page}>
            <SideNavigationBar />
            <main style={styles.mainContent}>
                <header style={styles.header}>
                    <IconButton onClick={() => navigate(-1)} style={{ marginRight: '1rem' }}>
                        <ArrowBackIcon />
                    </IconButton>
                    <h1 style={styles.title}> CareerCarve Employability Exam</h1>
                </header>

                {loading ? (
                    <div style={styles.centeredContainer}>
                        <p style={styles.loadingText}>Loading Data...</p>
                    </div>
                ) : (
                    <>


                        {allBatches.length > 0 ? (
                            <div style={styles.cardGrid}>
                                {allBatches.map((item, index) => (
                                    <div key={index} style={{ ...styles.card, position: "relative" }}>
                                        <div style={styles.cardHeader}>
                                            <h2 style={styles.collegeName}>{item.college_name}</h2>
                                            <p style={styles.batchName}>{item.group_name}</p>
                                        </div>

                                        <div style={styles.cardBody}>
                                            <p style={styles.dateText}>Start Date: {formatDate(item.start_date)}</p>
                                        </div>

                                        <div style={styles.cardBody}>
                                            <p style={styles.dateText}>End Date: {formatDate(item.end_date)}</p>
                                        </div>

                                        <div style={styles.cardBody}>
                                            <p style={styles.dateText}>Process ID: {(item.process_id)}</p>
                                        </div>

                                        {/* STATUS */}
                                        <div style={{ position: "absolute", top: "6px", right: "45px", zIndex: 1 }}>
                                            <p style={{ color: getStyle(item.start_date, item.end_date), fontSize: "1rem" }}>
                                                {getStatus(item.start_date, item.end_date)}
                                            </p>
                                        </div>

                                        {/* MENU */}
                                        <div style={{ position: "absolute", top: "6px", right: "10px", cursor: "pointer" }}>
                                            <div onClick={() => toggleMenu(index)}>⋮</div>

                                            {openMenu === index && (
                                                <div style={styles.dropdownMenu}>
                                                    {item.status === null && (
                                                        <p style={styles.menuItem} onClick={() => handeleDeclareCollegeReport(item)}>
                                                            Declare college report
                                                        </p>
                                                    )}

                                                    {item.status === "college_admin_report_inprogress" && (
                                                        <p style={styles.menuItem} >
                                                            College Report is in progress
                                                        </p>
                                                    )}
                                                    {item.status === "college_admin_report_declared" && (
                                                        <p
                                                            style={styles.menuItem}
                                                            onClick={() => confirmDeclareStudentReport(item)}
                                                        >
                                                            Declare student report
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        <footer style={styles.cardFooter}>
                                            <a
                                                href={`https://www.collegeadmin.careercarve.com/CollegeDashboard?id=${item.user_group_id}`}
                                                style={{ ...styles.button, ...styles.secondaryButton }}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                View College Admin
                                            </a>

                                            <button
                                                style={{ ...styles.button, ...styles.primaryButton }}
                                                onClick={() => handleDownload(item)}
                                            >
                                                Download excel
                                            </button>
                                        </footer>

                                        <div style={styles.cardFooterSecondary}>
                                            <button
                                                style={{
                                                    ...styles.button,
                                                    ...styles.reportButton,
                                                    ...(downloadingReport === item.process_id ? styles.buttonDisabled : {})
                                                }}
                                                onClick={() => handleDownloadCeeReport(item)}
                                                disabled={downloadingReport === item.process_id}
                                            >
                                                {downloadingReport === item.process_id
                                                    ? "Preparing report..."
                                                    : "Download CEE Report"}
                                            </button>
                                        </div>
                                    </div>

                                ))}
                            </div>
                        ) : (
                            <div style={styles.centeredContainer}>
                                <p style={styles.noDataText}>No Data Found</p>
                            </div>
                        )}
                    </>
                )}


                {showModal && (
                    <div style={styles.overlay}>
                        <div style={styles.container}>
                            <h3>Confirm Student Status Update</h3>

                            {loadingStudents ? (
                                <p>Loading students...</p>
                            ) : studentList.length > 0 ? (
                                <table style={styles.table}>
                                    <thead>
                                        <tr>
                                            <th>User</th>
                                            <th>New Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {studentList.map((s, i) => (
                                            <tr key={i}>
                                                <td>{s.user_id}</td>
                                                <td>{s.exam_status}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                <p>No students found to update</p>
                            )}

                            <div style={styles.footer}>
                                <button style={styles.cancel} onClick={() => setShowModal(false)}>
                                    Cancel
                                </button>

                                <button style={styles.confirm} onClick={confirmDeclareStudentReport}>
                                    Confirm Update
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <ToastContainer position="top-right" autoClose={4000} />
            </main>
        </div>
    );
};

// --- INLINE STYLES ---

const styles = {
    page: {
        display: 'flex',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
    },
    mockSidebar: {
        width: '80px',
        backgroundColor: '#ffffff',
        borderRight: '1px solid #dee2e6',
        padding: '1rem',
        textAlign: 'center',
        position: 'fixed',
        height: '100%',
    },
    mainContent: {
        flexGrow: 1,
        padding: '2rem 3rem',
        marginLeft: '100px', // Adjusted for mock sidebar
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '2rem',
    },
    iconButton: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '0.5rem',
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    title: {
        fontSize: '2.5rem',
        fontWeight: '600',
        color: '#343a40',
        margin: 0,
    },
    centeredContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh',
    },
    loadingText: {
        fontSize: '1.2rem',
        color: '#6c757d',
    },
    noDataText: {
        fontSize: '1.2rem',
        color: '#6c757d',
        fontWeight: '500',
    },
    cardGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
        gap: '2rem',
    },
    card: {
        position: 'relative',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
        padding: '1.5rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
        border: '1px solid #e9ecef',
    },
    cardHeader: {
        marginBottom: '1rem',
    },
    collegeName: {
        fontSize: '1.4rem',
        fontWeight: '600',
        color: '#212529',
        margin: '0 0 0.25rem 0',
    },
    batchName: {
        fontSize: '1rem',
        color: '#495057',
        margin: 0,
    },
    cardBody: {
        flexGrow: 1,
    },
    dateText: {
        fontSize: '0.9rem',
        color: '#6c757d',
    },
    cardFooter: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '0.75rem',
        marginTop: '1.5rem',
        paddingTop: '1rem',
        borderTop: '1px solid #e9ecef',
    },
    button: {
        width: '100%',
        padding: '0.6rem .8rem',
        fontSize: '0.8rem',
        fontWeight: '600',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background-color 0.2s, color 0.2s',
    },
    primaryButton: {
        backgroundColor: Color.primary1,
        color: '#ffffff',
    },
    secondaryButton: {
        backgroundColor: '#f1f3f5',
        color: '#495057',
    },
    // The CEE report sits on its own row, the footer already holds two buttons.
    cardFooterSecondary: {
        display: 'flex',
        marginTop: '0.75rem',
    },
    reportButton: {
        backgroundColor: '#ffffff',
        color: Color.primary1,
        border: `1px solid ${Color.primary1}`,
    },
    buttonDisabled: {
        opacity: 0.6,
        cursor: 'not-allowed',
    },

    dropdownMenu: {
        position: "absolute",
        top: "24px",
        right: "0px",
        background: "#fff",
        padding: "6px 10px",
        borderRadius: "6px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
        zIndex: 10,
        width: "150px",
    },
    menuItem: {

        fontSize: "12px",
        margin: "4px 0",
        cursor: "pointer",
    },

    overlay: {
        position: "fixed",
        top: 0, left: 0, width: "100%", height: "100%",
        backgroundColor: "rgba(0,0,0,0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 999,
    },
    container: {
        background: "#fff",
        padding: "20px",
        borderRadius: "8px",
        width: "450px",
        maxHeight: "80vh",
        overflowY: "auto",
    },
    table: {
        width: "100%",
        marginTop: "10px",
        borderCollapse: "collapse",
    },
    footer: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "20px",
    },
    confirm: {
        background: "green", color: "#fff", padding: "8px 16px", border: "none",
        borderRadius: "4px", cursor: "pointer",
    },
    cancel: {
        background: "gray", color: "#fff", padding: "8px 16px", border: "none",
        borderRadius: "4px", cursor: "pointer",
    }
};


export default EmployabilityData
